import { Component, NgZone, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { BucketsStatusService, BucketsStatusServiceData, BucketStatus } from "../../services/bucketStatusKpi/bucketsStatus.service";
import { BucketsStatusDetailService, BucketsStatusDetailServiceData } from "../../services/bucketStatusKpi/bucketsStatusDetail.service";
import { DoughnutChartData } from "../../../../dashboardCommon/components/cardContents/doughnutChart.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";

export class BucketStatusExtendedData
{
    public buckets: DoughnutChartData[] = [];
    public get total(): number {
        if (this.buckets) {
            return this.buckets.reduce<number>((acc, x) => acc + x.value, 0);
        } else {
            return 0;
        }
    };
}

@Component({
    selector: 'bucket-status-extended-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class BucketsStatusExtendedKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<BucketsStatusService, BucketsStatusServiceData, BucketStatusExtendedData, BucketsStatusDetailService, BucketsStatusDetailServiceData, BucketsStatusDetailServiceData>
    implements OnDestroy {
    public getClassName() { return "BucketsStatusExtendedKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: BucketsStatusService, detailService: BucketsStatusDetailService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: BucketsStatusServiceData): BucketStatusExtendedData {
        
        let result: BucketStatusExtendedData = null;
        let sortedBuckets = data.buckets.filter(x => x.remaining > 0).sort((a, b) => b.remaining - a.remaining);
        if (sortedBuckets.length == 0) {
            result = null;
        } else if (sortedBuckets.length > 4) {
            let buckets = sortedBuckets.slice(0, 3);

            let otherBuckets = sortedBuckets.slice(3)
                .reduce<{ bucketCount: number, remaining: number }>((acc, x) => {
                    acc.bucketCount++;
                    acc.remaining += x.remaining;
                    return acc;
                }, { bucketCount: 0, remaining: 0 });

            let otherBucketStatus = new BucketStatus();
            otherBucketStatus.name = "Otros {0}+".format(otherBuckets.bucketCount.toString());
            otherBucketStatus.remaining = otherBuckets.remaining;
            buckets.push(otherBucketStatus);

            result = buckets.reduce<BucketStatusExtendedData>((acc, x) => {
                acc.buckets.push(new DoughnutChartData(x.name, x.remaining));
                return acc;
            }, new BucketStatusExtendedData());
        } else {
            result = sortedBuckets.reduce<BucketStatusExtendedData>((acc, x) => {
                acc.buckets.push(new DoughnutChartData(x.name, x.remaining));
                return acc;
            }, new BucketStatusExtendedData());
        }
        return result;
    }

    protected extractUpdateTime(data: BucketsStatusServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: BucketsStatusDetailServiceData): BucketsStatusDetailServiceData {
        return data;
    }

    protected performDetailAction(): void {
        if (this.summaryData && this.detailData) window.open(this.detailData.link, "_blank");
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }
}